// Links carry an in-app anchor after the route (/#/leagues/1/rounds/2#zapisy).
// Messengers and some address bars percent-encode that second hash, which the
// HashRouter would then read as part of the route ("712%23zapisy") — restore it
// before the router mounts. Access codes never contain "#", so decoding is safe.
export function repairEncodedHashRoute(hash: string): string | null {
  if (!/%23/i.test(hash)) {
    return null;
  }

  return hash.replace(/%23/gi, '#');
}

export function anchorFromHash(hash: string): string | null {
  const name = hash.replace(/^#/, '').trim();

  return name.length > 0 ? name : null;
}
